export default "__VITE_ASSET__DvvPx$VX__"